import { Box } from '@mui/material';
import React from 'react';
import { FBCheckbox, FBEditorProperties, FBEditorProps, FBEditorState, FBEditorValidation, FBForm, FBProvider } from '..';
import { translate } from '../../../common/intl';
import { Autocomplete, FormField } from '../../components/forms/fields-next';
import Text from '../../components/Text';
import { StyledOption } from '../../documentRevision/forms/presenters/AvailableReferences.new.styles';
import { withFBEditor } from './FBEditor.wrap';

const FBEditor: React.FunctionComponent<FBEditorProps> = ({
  formState,
  inputProps: { type, index } = {},
  inputProps,
  editorState,
  children,
  underValidation,
  isFormOutput,
  mode,
  tabConfig,
  handleTabSelection,
  activeTabLabelId,
}) => (
  <FBProvider {...{ editorState }}>
    <FBForm initialValues={inputProps} {...{ formState }}>
      <Box hidden={mode === 'validation'}>
        <FormField
          label="form.builder.select.tab"
          margin="dense"
        >
          <Autocomplete
            blurOnSelect
            key={`fb-editor-auto-${type}-${index}`}
            options={tabConfig}
            onChange={handleTabSelection}
            value={translate(activeTabLabelId)}
            renderOption={(props, option) => (<StyledOption {...props}><Text translation={option.labelId} /></StyledOption>)}
            inputProps={{ style: { paddingTop: '3px' } }}
          />
        </FormField>
      </Box>
      <Box hidden={mode === 'validation'}>
        {children}
        {type && FBEditorState.omitFinalValidation.includes(type) && (
          <FBCheckbox name="omitFinalValidation" hidden={true} defaultChecked={true} />
        )}
        {!isFormOutput && (
          <FBEditorProperties
            key={`fb-editor-props-${type}-${index}`}
            {...{ type, inputProps }}
          />
        )}
      </Box>
      {underValidation && (
        <Box hidden={mode === 'config'}>
          <FBEditorValidation />
        </Box>
      )}
    </FBForm>
  </FBProvider>
);

export default withFBEditor(FBEditor);
